export default __webpack_public_path__ + "static/media/TotalCasesIcon.f2dbe674.svg";